<template lang="pug">
.card-container(
  :style="show?'height:0.92rem':(showHot?'height:0.86rem':'')")(@click='click')
  .left
    img(:src='getImgurl()')
  .right
    span.title {{ info.title }}
    .self-words(v-if='mode === 1&&info.paymentLimit') 续费{{info.purchasePrice}}元/月，可随时取消
    .words(v-if='(mode===1||mode===3)&&getlistlength(info)')
      | {{ info.cardDetail.commodityPackageItemDTO.
      | marketingWords.slice(0, 2).map((v) => v.wordsValue).join(" | ") }}
    .bottom(v-if="mode !== 3")
      span.hint(v-if='hot') 补贴价
      span.money.first(v-if='mode === 1&&!hot') ¥
      span.money-hot.first(v-if='mode === 1&&hot') ¥
      span.price(v-if='mode === 1&&!hot') {{ info.finalPrice }}
      span.price-hot(v-if='mode === 1&&hot') {{ info.finalPrice }}
      span.bigPrice(v-if='mode === 2||mode === 4' :style="hot?'line-height:0.1rem':''") ¥
      span.bigPriceMoney(v-if='mode === 2||mode === 4'
       :style="hot?'line-height:0.16rem':''") {{ info.finalPrice }}
      span.original.del(v-if='mode!==3&&!hot') ¥{{ info.originPrice }}
      span.original-hot.del(v-if='mode!==3&&hot') ¥{{ info.originPrice }}
      .save.flex-mid(v-if='!hot') 省{{ (info.originPrice- info.finalPrice).toFixed(2)}}元
  template(v-if='(mode===1||mode===2)&&!hot')
    .btn.flex-mid 马上抢
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '../../../../utils/params';
import {
  getTokenAndLocation,
} from '../../../../utils';

const DEFAULT_CARD = () => ({
  title: '单车30天不限次卡·APP专享',
  currentPrice: '32',
  businessType: 1,
  originPrice: '50',
  save: '18',
  img: '',
  commodityPackageItemDTO: {
    marketingWords: [],
  },
});
export default {
  props: {
    mode: {
      type: Number,
      default: 1,
      // 3.hotcard 2hot券 1列表 4挽留
    },
    info: {
      type: Object,
      default: DEFAULT_CARD,
    },
    hot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // tags: [],
    };
  },
  computed: {
    show() {
      return this.info.paymentLimit === 1 && this.mode === 1 && !this.hot;
    },
    showHot() {
      return this.info.paymentLimit === 1 && this.mode === 1 && this.hot;
    },
  },
  methods: {
    async click() {
      if (this.info.isCard) {
        UBT.clickButton({
          pageId: 'platform_appmarketing',
          buttonName: 'platform_appnewcard',
          categoryId: 'platform',
          businessInfo: {
            cardname: this.info.title,
            business: this.info.businessType,
          },
        });
        this.$emit('click', this.info);
      } else {
        UBT.clickButton({
          pageId: 'platform_appmarketing',
          buttonName: 'platform_appnewcoupon',
          categoryId: 'platform',
          businessInfo: {
            cardname: this.info.title,
            business: this.info.businessType,
          },
        });
        const { token, adCode, cityCode } = await getTokenAndLocation();
        window.location.href = ParamsUtil.addParams(this.info.buttonLink,
          { token, adCode, cityCode });
      }
    },
    getlistlength(item) {
      return item.cardDetail.commodityPackageItemDTO.marketingWords.length > 0 && item.cardDetail;
    },
    getImgurl() {
      if (this.info.isCard) {
        if (this.info.businessType === 1) {
          return 'https://m.hellobike.com/resource/helloyun/08345/pk_ddEy4zU.png?x-oss-process=image/quality,q_80';
        }
        return 'https://m.hellobike.com/resource/helloyun/08345/hZr1VLLWxy.png?x-oss-process=image/quality,q_80';
      }
      if (this.info.businessType === 1) {
        return 'https://m.hellobike.com/resource/helloyun/08345/6ETRKUQS3f.png?x-oss-process=image/quality,q_80';
      }
      return 'https://m.hellobike.com/resource/helloyun/08345/uJusi4L1FJ.png?x-oss-process=image/quality,q_80';
    },
  },
};
</script>

<style lang="less" scoped>
.card-container {
  display: flex;
  position: relative;
  justify-content: space-between;
  width: 100%;
  height: 0.72rem;

  .left {
    width: 0.56rem;
    height: 0.72rem;
    margin-right: 0.12rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .btn {
    position: absolute;
    right: 0;
    bottom: 0.04rem;
    width: 0.6rem;
    height: 0.28rem;
    background: linear-gradient(110deg, #ff5e63 0%, #ff2a3f 100%);
    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-weight: 600;
    color: #fff;
    line-height: 0.14rem;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 0.15rem;
      line-height: 1;
      font-weight: 500;
      color: #242729;
      margin-bottom: 0.02rem;
      white-space: nowrap;
      max-width: 2.4rem;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-top: 0.01rem;
    }

    .words {
      display: block;
      white-space: nowrap;
      margin-top: 0.05rem;
      font-size: 0.11rem;
      color: #5a6066;
      line-height: 0.16rem;
      width: 1.8rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .self-words {
      display: flex;
      white-space: nowrap;
      margin-top: 0.05rem;
      font-size: 0.11rem;
      color: #5a6066;
      line-height: 0.16rem;
    }

    .bottom {
      position: relative;
      display: inline-flex;
      margin-top: 0.06rem;
      align-items: flex-end;

      .hint {
        font-size: 0.11rem;
        color: #ff5526;
        line-height: 0.1rem;
        margin-right: 0.01rem;
      }

      .first {
        position: relative;
        top: -0.01rem;
      }

      .money {
        font-size: 0.12rem;
        font-weight: 600;
        color: #ff5103;
        line-height: 0.08rem;
        margin-right: 0.02rem;
      }

      .money-hot {
        font-size: 0.12rem;
        font-weight: 600;
        color: #ff5103;
        line-height: 0.09rem;
        margin-right: 0.02rem;
      }

      .bigPrice {
        font-size: 0.12rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #ff5526;
        line-height: 0.14rem;
      }

      .bigPriceMoney {
        font-size: 0.2rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #ff5526;
        line-height: 0.19rem;
      }

      .save {
        height: 0.16rem;
        border-radius: 0.04rem;
        border: 0.01rem solid rgba(255, 85, 38, 0.3);
        font-size: 0.11rem;
        color: #fa4614;
        line-height: 0.12rem;
        padding: 0 0.03rem;
      }

      .price {
        height: 0.16rem;
        font-size: 0.2rem;
        font-weight: 600;
        color: #ff5103;
        line-height: 0.16rem;
        margin-right: 0.05rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      }

      .price-hot {
        height: 0.15rem;
        font-size: 0.2rem;
        font-weight: 600;
        color: #ff5103;
        line-height: 0.16rem;
        margin-right: 0.05rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      }

      .original {
        margin-left: 0.04rem;
        font-size: 0.11rem;
        font-weight: 400;
        color: #879099;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        line-height: 0.11rem;
        margin-right: 0.06rem;
      }

      .original-hot {
        margin-left: 0.04rem;
        font-size: 0.11rem;
        font-weight: 400;
        color: #879099;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        line-height: 0.1rem;
        margin-right: 0.06rem;
      }

      .originalCancel {
        margin-left: 0.04rem;
        font-size: 0.11rem;
        font-weight: 400;
        color: #879099;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        line-height: 0.16rem;
      }
    }
  }
}
</style>
